import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";

import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";
import { useCookies } from "react-cookie";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { Loader } from "./BYOB/StyledComponents";
import { ApolloProvider } from "@apollo/react-hooks";
import { ByobBase, NoMatch } from "./BYOB";
import { Global } from "@emotion/core";
import { ReactComponent as Check } from "./svg/check.svg";
import { ReactComponent as Info } from "./svg/info.svg";
import {
  globalStyles,
  TabBar,
  Tab,
  ActiveTab,
  Trans,
} from "./BYOB/StyledComponents";
import {
  Stage,
  Materials,
  Headboards,
  Legs,
  Topper,
  BedsideTable,
  Ottoman,
  AddOns,
  Style,
  Overview,
} from "./BYOB/parts";

let uri, prefix;
const isDev = process.env.NODE_ENV === "development";

if (isDev) {
  uri = "http://localhost:4444/graphql/";
  prefix = "";
} else {
  uri = "https://byob.jensen-beds.com/graphql/";
  prefix = "/byob";
}

export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}

const get_bed = () => {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get("bed");

  if (parseInt(c)) {
    return c ? { id: parseInt(c), slug: "" } : { id: 361, slug: "" };
  } else {
    return c ? { slug: c } : { id: 361, slug: "" };
  }
};

const get_param = (param, def) => {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get(param);
  return c ? c : def;
};

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    new HttpLink({
      uri: uri,
      credentials: "include",
    }),
  ]),
  cache: new InMemoryCache(),
});

const ComponentRouter = ({ component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return <ByobBase {...rest} {...routeProps} />;
      }}
    />
  );
};

const InitialData = ({ selected, setSelected }) => {
  const [refetched, setRef] = useState(false);
  const { loading, error, data, refetch } = useQuery(
    gql`
      query baseBed($slug: String!) {
        initialBed(slug: $slug) {
          id
          slug
          title
          height
          hasAddons
          hasOttomans
          seamless
          legs {
            id
            height
            title
          }
          textile {
            img
            type
            id
            hid
            title
          }
          topper {
            id
            img
            type
            title
          }
          background {
            title
            img
            id
            type
          }
        }
      }
    `,
    {
      variables: {
        slug: selected.bed.slug,
      },
      client: client,
    }
  );
  useEffect(() => {
    if (data && data.initialBed === null) {
      setRef(true);
      refetch({ slug: selected.bed.slug.replace("/", "-") });
    }

    if (data && data.initialBed !== null && !loading) {
      console.log("KIKA", data);
      const {
        legs,
        textile,
        topper,
        slug,
        title,
        height,
        background,
        id,
        hasOttomans,
        hasAddons,
      } = data.initialBed;
      if (data.initialBed.main_slug === undefined) {
        const has_seamless = data.initialBed.seamless;
        console.log(has_seamless);
        const seam_fixer = (img, selected) => {
          if (!has_seamless) {
            return img;
          }

          if (data.initialBed.slug === "continental") {
            img = replaceAll(img, "Continental", "Continental_Seamless");
          }

          if (data.initialBed.slug === "aqtive-ii") {
            img = replaceAll(img, "Aqtive_II", "Aqtive_II_Seamless");
          }

          if (data.initialBed.slug === "aqtive-i") {
            img = replaceAll(img, "Aqtive_I", "Aqtive_I_Seamless");
          }

          if (data.initialBed.slug === "dream") {
            img = replaceAll(img, "Dream", "Dream_Seamless");
          }
          return img;
        };
        setSelected((s) => ({
          ...s,
          bed: {
            id: id,
            slug: slug,
            main_slug: refetched
              ? selected.bed.slug.replace("/", "-")
              : selected.bed.slug,
            title: title,
            height: height,
          },
          legs: legs,
          textiles: {
            id: textile?.id,
            img: seam_fixer(textile?.img),
            hid: textile?.hid,
            title: textile?.title,
            seamless: has_seamless,
          },
          topper: {
            id: topper.id,
            byob: topper.img,
            title: topper.title,
          },
          background: background,
          hasOttomans: hasOttomans,
          hasAddons: hasAddons,
        }));
      }
    }
  }, [
    data,
    loading,
    setSelected,
    selected.bed.slug,
    setRef,
    refetch,
    refetched,
  ]);
  if (error) return null;
  if (loading) return <Loader refetched={refetched} />;

  return null;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      info: null,
    };
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info,
    });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Oops, something went wrong :(</h1>
          <p>The error: {this.state.error.toString()}</p>
          <p>Where it occured: {this.state.info.componentStack}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const RouteFixer = ({ setParams }) => {
  const { search } = useLocation();
  setParams(search);
  return null;
};

const App = () => {
  const [cookies, setCookie] = useCookies(["market-prefix", "byob-lang"]);
  setCookie("market-prefix", get_param("market", "no"), { path: "/" });
  setCookie("byob-lang", get_param("lang", "nb"), { path: "/" });
  setCookie("market-prefix", get_param("market", "no"), { path: "/" });
  console.log(cookies);
  const baseObj = {
    bed: get_bed(),
  };
  const [selected, setSelected] = useState(baseObj);
  const [params, setParams] = useState(baseObj);
  return (
    <ApolloProvider client={client}>
      <InitialData selected={selected} setSelected={setSelected} />
      <Global styles={globalStyles} />

      <Router>
        <RouteFixer setParams={setParams} />
        <Stage selected={selected} />
        <TabBar>
          <Tab to={`${prefix}/style${params}`}>
            <Trans>Style</Trans> {selected.background && <Check />}
          </Tab>
          <Tab to={`${prefix}/textiles${params}`}>
            <Trans>Textile</Trans> {selected.textiles && <Check />}
          </Tab>
          <Tab to={`${prefix}/topper${params}`}>
            <Trans>Topper</Trans> {selected.topper && <Check />}
          </Tab>
          <Tab to={`${prefix}/legs${params}`}>
            <Trans>Leg</Trans> {selected.legs && <Check />}
          </Tab>
          <Tab to={`${prefix}/headboards${params}`}>
            <Trans>Headboard</Trans> {selected.headboards && <Check />}
          </Tab>
          <Tab to={`${prefix}/bedsidetable${params}`}>
            <Trans>Bedside table</Trans> {selected.bedsidetable && <Check />}
          </Tab>
          {selected?.hasOttomans && (
            <Tab to={`${prefix}/ottoman${params}`}>
              <Trans>Ottoman</Trans> {selected.ottoman && <Check />}
            </Tab>
          )}
          {selected?.hasAddons && (
            <Tab to={`${prefix}/addons${params}`}>
              <Trans>Add ons</Trans>{" "}
              {selected.addons && selected.addons.length > 0 && <Check />}
            </Tab>
          )}

          <Tab to={`${prefix}/overview${params}`}>
            <Trans>Overview</Trans>
            <Info />
          </Tab>
        </TabBar>
        {selected.bed.main_slug !== undefined && (
          <ActiveTab>
            {console.log("NU?", selected)}
            <ErrorBoundary>
              <Switch>
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="background"
                  display_component={Style}
                  path={`${prefix}/style`}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="textiles"
                  display_component={Materials}
                  path={`${prefix}/textiles`}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="headboards"
                  display_component={Headboards}
                  path={`${prefix}/headboards`}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="legs"
                  path={`${prefix}/legs`}
                  display_component={Legs}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="topper"
                  path={`${prefix}/topper`}
                  display_component={Topper}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="ottoman"
                  path={`${prefix}/ottoman`}
                  display_component={Ottoman}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="bedsidetable"
                  path={`${prefix}/bedsidetable`}
                  display_component={BedsideTable}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="addons"
                  path={`${prefix}/addons`}
                  display_component={AddOns}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="Overview"
                  display_component={Overview}
                  path={`${prefix}/OverView`}
                />
                <ComponentRouter
                  setSelected={setSelected}
                  selected={selected}
                  type="background"
                  display_component={Style}
                  path={`${prefix}/`}
                />

                <Route component={NoMatch} />
              </Switch>
            </ErrorBoundary>
          </ActiveTab>
        )}
      </Router>
    </ApolloProvider>
  );
};

export default App;
